import { type UseQueryResult, useQuery } from 'react-query';
import { TradePreClearanceService } from '../../services/wealthlane-award-services';

const useGetPreClearanceApprovalStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const preClearanceApprovalStatus = useQuery(
    ['getPreClearanceApprovalStatus'],
    async () => {
      return await handleRequest(
        TradePreClearanceService.getApiAwardApiAppTradePreClearanceApprovalStatus()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return preClearanceApprovalStatus;
};

export default useGetPreClearanceApprovalStatus;
